import React from 'react'
import { GFTeacherUser } from './../../models/models';
import { find } from 'lodash';
import {
  Button,
  Col,
  ListGroup,
  ListGroupItem,
  Row
} from "react-bootstrap";
import constants from '../../constants';
import { browserHistory } from 'react-router';

const FontAwesome = require("react-fontawesome");

interface Props extends React.Props<TeachersList> {
  filteredTeachers: GFTeacherUser[],
  showEditTeacher: (teacher: GFTeacherUser) => void,
  showDeleteTeacher: (teacher: GFTeacherUser) => void,
  loading: boolean;
  showAddTeacher: () => void;
  openSeats: number;
  loadTeachers: () => GFTeacherUser[],
}

interface State {}

class TeachersList extends React.Component<Props, State> {

  /**
   * The constructor
   * @param props
   */
  constructor(props: Props) {
    super(props);
    this.state = {}
  }

  /**
   * Renders the component
   *
   * @returns Modal
   */
  render () {
    const { loading, openSeats, filteredTeachers, showAddTeacher, showEditTeacher, showDeleteTeacher } = this.props;
    return (
      <ListGroup className="teachers-list">
      {filteredTeachers.map((teacher) => {
        const plan = find(constants.paymentPlanObjectsByID, plan => {
          return plan.id === teacher.paymentPlan;
        });
        return <ListGroupItem className="list-item" key={teacher.id}>
          <Row>
            <Col xs={3}>
              {teacher.first} {teacher.last}
            </Col>
            <Col xs={3}>
              <small>{teacher.email}</small>
            </Col>
            <Col xs={2}>
              {!!teacher.socialType && (
                <small>Registered via Google</small>
              )}
            </Col>
            <Col xs={2}>
              {`${teacher.totalStudents} student${teacher.totalStudents === 1 ? '' : 's'}`}
            </Col>
            <Col xs={2}>
              <div className="fa-icons" style={{ whiteSpace: 'nowrap' }}>
                <Button
                  title="Remove Teacher"
                  bsStyle="link"
                  className="pull-right"
                  onClick={() => {
                    showDeleteTeacher(teacher);
                  }}
                >
                  <FontAwesome name="times" />
                </Button>
                <Button
                  title="Performance Metrics"
                  bsStyle="link"
                  className="pull-right"
                  onClick={() => {
                    browserHistory.push(`/performance-metrics/${teacher.id}`);
                  }}
                >
                  <FontAwesome name="bar-chart" />
                </Button>
              </div>
            </Col>
          </Row>
        </ListGroupItem>
      })}
      {filteredTeachers.length === 0 && ! loading && (
      <div className='padded'>
        <h2>Hi, there!</h2>
        <p>It looks like you have not connected any teachers under your administrator account. Click "Add Teacher" when you are ready to get started!</p>

        <Button bsStyle={'default'} disabled={loading} className="btn-sm" onClick={showAddTeacher} style={{ marginTop: 8 }}>
          <FontAwesome name="plus" />
          Add Teacher
        </Button>

      </div>
      )}
    </ListGroup>
    );
  }
}

export default TeachersList;
